import { connect } from 'react-redux';
import { getCurrentView } from '@hc/redux-saga-router-plus/lib/selectors';

import {
  COMP_TYPE_DEFAULT,
  NULL_STATE_WARNINGS,
  MAP_ID_REPORT,
  MAP_ID_SEARCH,
  MAP_ID_COMPS,
  MAP_ID_RENTAL_COMPS,
  MAP_ID_LOCATION
} from 'legacy/appstore/constants';
import { COMP_MAP_PAGE } from 'legacy/routes/constants';

import { getSubjectLocationUnknown } from 'selectors/subject';
import { getMapDrawPolygons } from 'selectors/map-draw';
import { getPropertyResultLocationUnknown } from 'selectors/property-search';
import { getIsReportEditable } from 'selectors/report-permissions';
import { getLocationUnknownView } from 'selectors/property-explorer';
import { getIsMobile } from 'selectors/match-media';

import LocationUnknownWarning from 'legacy/components/LocationUnknownWarning';

const mapStateToProps = (state, ownProps) => {
  const { compType, mapId, position } = ownProps;
  const view = getCurrentView(state);
  const isSearchMap = mapId === MAP_ID_SEARCH;
  const isMobile = getIsMobile(state);
  const locationUnknown = isSearchMap
    ? getPropertyResultLocationUnknown(state)
    : getSubjectLocationUnknown(state);
  if (locationUnknown) {
    const drawLayerPolygons = getMapDrawPolygons(mapId)(state);
    const hasCompArea = drawLayerPolygons && drawLayerPolygons.length;
    const isMapPage = COMP_MAP_PAGE.indexOf(view) > -1;
    const isHeaderMap = mapId === MAP_ID_REPORT;
    const isCompMap = mapId === MAP_ID_COMPS || mapId === MAP_ID_RENTAL_COMPS;
    const isReportEditable = getIsReportEditable(state);
    const copy =
      mapId === MAP_ID_LOCATION
        ? NULL_STATE_WARNINGS.locationUnknownLocationMap
        : isSearchMap
        ? NULL_STATE_WARNINGS.locationUnknownSearchMap
        : NULL_STATE_WARNINGS.locationUnknown;
    return {
      title: copy.title,
      message:
        (isSearchMap || !isReportEditable || (!isHeaderMap && !hasCompArea)) &&
        copy.message,
      buttonLabel: compType === COMP_TYPE_DEFAULT ? 'Update' : 'Update',
      buttonView: getLocationUnknownView(mapId)(state),
      position:
        position || (hasCompArea && !isMapPage ? 'bottomRight' : 'center'),
      hideCTA:
        isMobile ||
        !isReportEditable ||
        isMapPage ||
        isSearchMap ||
        (isCompMap && hasCompArea),
      showWarning: locationUnknown
    };
  }
  return {};
};

export default connect(mapStateToProps)(LocationUnknownWarning);
